var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "draggable",
        {
          attrs: {
            options: {
              animation: 300,
              handle: ".icon-drag"
            },
            list: _vm.dataActions,
            group: "blockActionDragg"
          },
          on: { start: _vm.handleStartDrag, end: _vm.handleEndDrag }
        },
        _vm._l(_vm.dataActions, function(val, index) {
          return _c(
            "div",
            {
              key: val.id,
              attrs: {
                "data-parent": JSON.stringify(_vm.dataParent),
                row: _vm.row
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-action-add-automation-plus",
                  attrs: { id: "automationAddBlock-" + val.id },
                  on: {
                    click: function($event) {
                      _vm.openPopoverAdd("popoverAddAutomationBlock-" + val.id)
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-plus" })]
              ),
              _vm._v(" "),
              _vm.popoverAddBlock &&
              _vm.popoverAddBlock === "popoverAddAutomationBlock-" + val.id
                ? _c(
                    "b-popover",
                    {
                      ref: "popoverAddAutomationBlock-" + val.id,
                      refInFor: true,
                      attrs: {
                        target: "automationAddBlock-" + val.id,
                        triggers: "manual",
                        placement: "bottom"
                      }
                    },
                    [
                      _c("ModalListAction", {
                        directives: [
                          {
                            name: "click-outside",
                            rawName: "v-click-outside",
                            value: _vm.hideAllPopoverAdd,
                            expression: "hideAllPopoverAdd"
                          }
                        ],
                        attrs: {
                          "last-index": index,
                          "modal-ref": "popoverAddAutomationBlock-" + val.id
                        },
                        on: { select: _vm.selectActionBlock }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              val.type === "action"
                ? _c("j-automation-action", {
                    ref: "automationAction-" + val.id,
                    refInFor: true,
                    attrs: {
                      id: val.id,
                      "data-index": index,
                      "data-edit": val.dataEdit,
                      "data-parent": _vm.dataParent,
                      row: _vm.row
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              val.type === "javascript"
                ? _c("j-automation-javascript", {
                    ref: "automationJavascript-" + val.id,
                    refInFor: true,
                    attrs: {
                      id: val.id,
                      "data-index": index,
                      "data-edit": val.dataEdit,
                      "data-parent": _vm.dataParent,
                      row: _vm.row
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              val.type === "conditional"
                ? _c("j-automation-conditional", {
                    ref: "automationConditional-" + val.id,
                    refInFor: true,
                    attrs: {
                      id: val.id,
                      "data-index": index,
                      "data-edit": val.dataEdit,
                      "data-parent": _vm.dataParent,
                      row: _vm.row
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              val.type === "while"
                ? _c("j-automation-while", {
                    ref: "automationWhile-" + val.id,
                    refInFor: true,
                    attrs: {
                      id: val.id,
                      "data-index": index,
                      "data-edit": val.dataEdit,
                      "data-parent": _vm.dataParent,
                      row: _vm.row
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "hierarchy-line-vertical" }),
              _vm._v(" "),
              val.type !== "conditional" && val.type !== "while"
                ? _c("div", { staticClass: "hierarchy-line-arrow-down" })
                : _vm._e(),
              _vm._v(" "),
              (val.type === "conditional" || val.type === "while") &&
              val.dataEdit
                ? _c("div", { staticClass: "wrap-tree-layer" }, [
                    _c("div", { staticClass: "wrap-layer-left" }, [
                      _c("div", { staticClass: "horizontal-line-left" }, [
                        _c("div", { staticClass: "line" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "label-true-conditional",
                          class: {
                            "label-while-conditional": val.type === "while"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                val.type === "conditional" ? "TRUE" : "WHILE"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "hierarchy-line-vertical-true"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hierarchy-line-arrow-down" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wrap-diagram-tree" },
                        [
                          _c("diagram-view", {
                            attrs: {
                              "data-actions": val.array_left,
                              row: _vm.row + 1,
                              "data-parent": _vm.dataParent.concat([
                                {
                                  index: index,
                                  type: val.type,
                                  position: "array_left",
                                  is_disable: val.dataEdit.is_disable
                                }
                              ])
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-action-add-automation-plus",
                              staticStyle: { "margin-bottom": "20px" },
                              attrs: { id: "automationAddLeft-" + val.id },
                              on: {
                                click: function($event) {
                                  _vm.openPopoverAdd(
                                    "popoverAddAutomationLeft-" + val.id
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-plus" })]
                          ),
                          _vm._v(" "),
                          _vm.popoverAddBlock &&
                          _vm.popoverAddBlock ===
                            "popoverAddAutomationLeft-" + val.id
                            ? _c(
                                "b-popover",
                                {
                                  ref: "popoverAddAutomationLeft-" + val.id,
                                  refInFor: true,
                                  attrs: {
                                    target: "automationAddLeft-" + val.id,
                                    triggers: "manual",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("ModalListAction", {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideAllPopoverAdd,
                                        expression: "hideAllPopoverAdd"
                                      }
                                    ],
                                    attrs: {
                                      "last-index": index,
                                      "modal-ref":
                                        "popoverAddAutomationLeft-" + val.id,
                                      position: "array_left",
                                      row: _vm.row + 1,
                                      "data-parent": _vm.dataParent.concat([
                                        {
                                          index: index,
                                          type: val.type,
                                          position: "array_left"
                                        }
                                      ])
                                    },
                                    on: { select: _vm.selectActionBlock }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hierarchy-line-vertical" },
                            [_c("div", { staticClass: "dots-line" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "horizontal-line-bottom-left" },
                        [_c("div", { staticClass: "line" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "wrap-layer-right" }, [
                      _c("div", { staticClass: "horizontal-line-right" }, [
                        _c("div", { staticClass: "line" })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "label-false-conditional",
                          class: {
                            "label-done-conditional": val.type === "while"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                val.type === "conditional" ? "FALSE" : "DONE"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "hierarchy-line-vertical-false"
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "hierarchy-line-arrow-down" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wrap-diagram-tree" },
                        [
                          _c("diagram-view", {
                            attrs: {
                              "data-actions": val.array_right,
                              row: _vm.row + 1,
                              "data-parent": _vm.dataParent.concat([
                                {
                                  index: index,
                                  type: val.type,
                                  position: "array_right",
                                  is_disable: val.dataEdit.is_disable
                                }
                              ])
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "btn-action-add-automation-plus",
                              staticStyle: { "margin-bottom": "20px" },
                              attrs: { id: "automationAddRight-" + val.id },
                              on: {
                                click: function($event) {
                                  _vm.openPopoverAdd(
                                    "popoverAddAutomationRight-" + val.id
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-plus" })]
                          ),
                          _vm._v(" "),
                          _vm.popoverAddBlock &&
                          _vm.popoverAddBlock ===
                            "popoverAddAutomationRight-" + val.id
                            ? _c(
                                "b-popover",
                                {
                                  ref: "popoverAddAutomationRight-" + val.id,
                                  refInFor: true,
                                  attrs: {
                                    target: "automationAddRight-" + val.id,
                                    triggers: "manual",
                                    placement: "bottom"
                                  }
                                },
                                [
                                  _c("ModalListAction", {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideAllPopoverAdd,
                                        expression: "hideAllPopoverAdd"
                                      }
                                    ],
                                    attrs: {
                                      "last-index": index,
                                      "modal-ref":
                                        "popoverAddAutomationRight-" + val.id,
                                      position: "array_right",
                                      row: _vm.row + 1,
                                      "data-parent": _vm.dataParent.concat([
                                        {
                                          index: index,
                                          type: val.type,
                                          position: "array_right"
                                        }
                                      ])
                                    },
                                    on: { select: _vm.selectActionBlock }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "hierarchy-line-vertical" },
                            [_c("div", { staticClass: "dots-line" })]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "horizontal-line-bottom-right" },
                        [_c("div", { staticClass: "line" })]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              val.type === "conditional" || val.type === "while"
                ? [
                    _c("div", { staticClass: "hierarchy-line-vertical-true" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "hierarchy-line-arrow-down" })
                  ]
                : _vm._e()
            ],
            2
          )
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-358e0f62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-358e0f62","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/DiagramView.vue
// module id = null
// module chunks = 